import ar_EG from 'antd/es/locale/ar_EG';
import arMsg from "../locales/ar_EG.json";

const ArLang = {
  antd: ar_EG,
  locale: 'ar-EG',
  messages: {
    ...arMsg
  },
};
export default ArLang;
